import { combineReducers } from '@reduxjs/toolkit';

import * as sidebar from './sidebar';
import * as user from './user';

export const reducers = combineReducers({
    user: user.reducers,
    sidebar: sidebar.reducers,
});

export const actions = {
    user: user.actions,
    sidebar: sidebar.actions,
};
